import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgUpDown = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        d="M11.364 4.363a.9.9 0 0 1 1.272 0l4 4a.9.9 0 1 1-1.272 1.273L12 6.272 8.636 9.636a.9.9 0 1 1-1.272-1.273zM7.364 14.363a.9.9 0 0 1 1.272 0L12 17.727l3.364-3.364a.9.9 0 1 1 1.273 1.273l-4 4a.9.9 0 0 1-1.273 0l-4-4a.9.9 0 0 1 0-1.273"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgUpDown;
